
window.addEventListener('DOMContentLoaded', () => {

    let headerSelectPlaceholder = [...document.querySelector('#search-product-type').children][0]
    if ( window.innerWidth <= 765 ) {

        if (headerSelectPlaceholder) {
            headerSelectPlaceholder.innerText = headerSelectPlaceholder.innerText.split(' ')[0]
        }
    }

    document.addEventListener('click', (evt) =>{
      if(window.innerWidth > 749 ) return

      const summary = evt.target.closest('.menu-collapsable')
      const seeMore = evt.target.closest('.menu-drawer__see-more')
      const footerCollapsable = evt.target.closest('.footer-block__heading--container')

      if (summary) {
        summary.classList.toggle('menu-collapsable--open')
        summary.firstElementChild.classList.toggle('open')
        if (summary.firstElementChild.classList.contains('open')) {
          summary.nextElementSibling.style.height = `${summary.nextElementSibling.scrollHeight + 10}px`
        }else{
          summary.nextElementSibling.style.height = `0px`
        }
      }
      if (seeMore) {
        [...seeMore.parentElement.parentElement.children].forEach(li => {
          li.classList.remove('visually-hidden')
          seeMore.classList.add('visually-hidden')
        })
      }
      if (footerCollapsable) {
        const collapsableContainer = footerCollapsable.nextElementSibling

        collapsableContainer.classList.toggle('list-unstyled--open')

        if (collapsableContainer.classList.contains('list-unstyled--open')) {
          collapsableContainer.style.height = `${collapsableContainer.scrollHeight + 10}px`
          collapsableContainer.style.marginTop = `2rem`
          footerCollapsable.querySelectorAll('.svg_collapsable')[0].classList.remove('open');
          footerCollapsable.querySelectorAll('.svg_collapsable')[1].classList.add('open');
        }else{
          collapsableContainer.style.height = `0px`
          collapsableContainer.style.marginTop = `0px`
          footerCollapsable.querySelectorAll('.svg_collapsable')[1].classList.remove('open');
          footerCollapsable.querySelectorAll('.svg_collapsable')[0].classList.add('open');
        }
      }
    })

})
